<!-- Header only layout -->

<dashboard-header-nav></dashboard-header-nav>

<div class="app-content">
    <router-outlet pulseSupportContext></router-outlet>
</div>

<!-- global utilities (optional shared ones) -->
<app-scroll-top></app-scroll-top>
<loading></loading>
